export var getPieRadius = function getPieRadius(radiusCofig) {
  var radius = {};

  if (Array.isArray(radiusCofig)) {
    radius.inside = radiusCofig[0];
    radius.outside = radiusCofig[1];
  } else {
    radius.outside = radiusCofig;
    radius.inside = 0;
  }

  radius.inside = parseFloat(radius.inside);
  radius.outside = parseFloat(radius.outside);
  return radius;
};